import { token } from '@/infrastructure/container';

export interface IDomLocale {
  /** The browser's preferred language tag, e.g. "fr-FR". */
  language(): string;
}

export const TOKEN_IDomLocale = token<IDomLocale>('IDomLocale');

export class DomLocale implements IDomLocale {
  language(): string {
    return navigator.language;
  }
}

export class FakeDomLocale implements IDomLocale {
  constructor(private lang: string) {}
  language(): string {
    return this.lang;
  }
}
